import { Badge, Box, Text } from '@chakra-ui/react';
import { buyerCurrencyFormatter } from '@diamond/shared/utils';
import {
  CompiledProductDiscounts,
  ProductWithPromo,
} from '@diamond/sol-buyer/utils';

type PromoPriceProps = {
  data: ProductWithPromo;
};

export function PromoPriceOrderDetail({ data }: PromoPriceProps) {
  const productPrice = data?.price ?? 0;
  const confirmedPrice = data?.latest_price;
  const isDiscount = data?.hasDiscount;
  const discountData =
    isDiscount && Array.isArray(data?.compiled_discount)
      ? (data.compiled_discount as CompiledProductDiscounts[]).find(
          (promo) => promo.is_discount
        )
      : null;
  const discountAmount = (discountData?.deduction_amount ?? 0) / 100;

  return (
    <Box display="flex" gap="1" alignItems="center">
      <Text
        color="gray.75"
        textDecoration="line-through"
        fontSize={{ base: 'xs', md: 'sm' }}
      >
        {buyerCurrencyFormatter(confirmedPrice ?? productPrice)}
      </Text>
      {isDiscount ? (
        <Badge
          color="#FF0000"
          bgColor="#FFDADA"
          rounded="4px"
          fontSize={{ base: '2xs', md: 'xs' }}
        >
          {`${discountAmount}%`}
        </Badge>
      ) : null}
    </Box>
  );
}
